import React from "react";
import Form from "./common/form";
import { restoreCompany } from "../services/companyService";
import BackGroundRectangle from "../components/backgroundRect";

class CompanyRestoreForm extends Form {
  state = {
    errors: {}
  };

  handleRestore = async e => {
    e.preventDefault();
    await restoreCompany(this.props.match.params.id);
    this.props.history.push("/companies");
  };

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            width: "350",
            position: "fixed",
            left: "50%",
            transform: "translateX(-50%)",
            marginTop: "150px",
            marginBottom: "150px",
            zIndex: 1
          }}
        >
          <p className="basicParagraph">
            You are about to restore {this.props.match.params.id}.
          </p>
          <p className="basicParagraph">Please confirm:</p>
          <button
            className="btn btn-success btn-sm"
            onClick={this.handleRestore}
          >
            Confirm
          </button>
        </div>
        <BackGroundRectangle />
      </React.Fragment>
    );
  }
}

export default CompanyRestoreForm;
